import Client from '../../helpers/ApiClient';
import Component from '../Component';
import {TreePicker} from 'reactis-inputs';
import React from 'react';

export default class SectorPicker extends Component {

	api(callback) {
		const client = new Client();
		client.call('sector.getList').then((data) => {
			callback(data.tree);
		});
	}

	render() {
		return <TreePicker getData={(callback) => this.api(callback)} {...this.props} />
	}
}




// WEBPACK FOOTER //
// ./src/components/Form/SectorPicker.js